module.exports = __webpack_public_path__ + "media/assets/svg/components/hexagon_outline-4fe2d844fe2d4e5e5e7d8e09e2556d7e.svg";